export function ConvertOverridesToView(ruleData) {
  const layout = ruleData.layout;
  const view = ruleData.view;
  const doc = ruleData.doc;
  let wsMgr = doc.GetDocMgr().fWSMgr;
  view.SetDirty(true);
  layout.ClearOverrides();
  let layoutMgr = doc.GetLayoutMgr();
  layoutMgr.UpdateOverrideInfo(layout);
  wsMgr.fCanvasPanel.AutoFormat();
  wsMgr.RenderWS();
}
